import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SeriesLandingRedirect from './SeriesLandingRedirect';

/**
 * /series-bible is retired. #670 / #682: leftover Series Notes links
 * are not a working front door. Apply the first-open lock: empty →
 * Series Discovery, pins → Timeline.
 */
function SeriesBiblePage() {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('project');
  return <SeriesLandingRedirect projectId={projectId} />;
}

export default SeriesBiblePage;
